<div class="chapter">

  <mat-accordion multi="true">

    <mat-expansion-panel (opened)="openChapter()" (closed)="isServiceLoaded = false"  class="quot-chapter">
      <mat-expansion-panel-header class="quot-chapter-header" [collapsedHeight]="'100px'" [expandedHeight]="'100px'">
        <mat-panel-title class="quot-chapter-title lw-grey">
          {{globalFunction.capitalizeFirstLetter(chapter.title) || "Sans Titre" }}
        </mat-panel-title>
        <mat-panel-description class="quot-chapter-desc">

          <mat-grid-list cols="3" rowHeight="100px" style="height: calc(20px);width: 100%;">
            <mat-grid-tile class="quot-chapter-tile-comment" [colspan]="1"></mat-grid-tile>
            <mat-grid-tile class="quot-chapter-tile-price" [colspan]="2">
              <span class="quot-chapter-price lw-grey">{{ calculateTotalChapterPrice() |currency:'EUR':'symbol'}} HT </span>
            </mat-grid-tile>
          </mat-grid-list>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="quot-chapter-content">

        <div *ngFor="let service of services">
        <ng-container *ngIf="isServiceLoaded">
          <app-service
            [project]="project"
            [service]="service"
            [quotation]="quotation"
            [quotationId]="quotationId"
            [versionId]="versionId">
          </app-service>
        </ng-container>
        </div>

      </div>

    </mat-expansion-panel>

  </mat-accordion>
</div>
